import React, { Component } from "react";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { INITIAL_PAGINATION } from "../../constant";
import FlexView from "react-flexview";
import SimpleInput from "../../../../../modules/SimpleInput";
import {
  fetchDataAsync,
  FormatCurrencyRupiah,
} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../../common/Constants";
import { getClaimPartTableConfig } from "./config";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

export default class ClaimPartSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: INITIAL_PAGINATION,
      baseOptions: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  getTableColumn = () => {
    const { onSaveData, onEditData, onDeleteData, onChangeData, activityType } =
      this.props;
    const { baseOptions } = this.state;

    const isView = activityType === ACTIVITY_TYPE.VIEW;
    const isDelete = activityType === ACTIVITY_TYPE.DELETE;

    const isDisable = isView || isDelete;
    return getClaimPartTableConfig({
      onSaveData: onSaveData,
      onEditData: onEditData,
      onDeleteData: onDeleteData,
      onChangeData: onChangeData,
      options: baseOptions,
      isDisable: isDisable,
    });
  };

  fetchData = async (body) => {
    const { setError, selectedCabang } = this.props;
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPartManagementClaim,
      menuName: "Management Claim",
      setError: setError,
      args: {
        kodeCabang: selectedCabang?.value,
        paramFilters: {},
      },
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        baseOptions: res.data.data,
      });
    }
  };

  handleChangePage = (tableState) => {
    const limit = tableState.rowsPerPage;
    const page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
        limit: limit,
      },
    }));
  };

  handleChangeRowsPerPage = (tableState) => {
    const limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        totalData: 0,
        page: 1,
        limit: limit,
      },
    }));
  };

  render() {
    const { pagination } = this.state;
    const {
      onAddData,
      dataTable,
      totalHet,
      totalOngkosKerja,
      totalAmount,
      activityType,
    } = this.props;

    const isDelete = activityType === ACTIVITY_TYPE.DELETE;
    const isView = activityType === ACTIVITY_TYPE.VIEW;
    const isDisable = isView || isDelete;
    return (
      <React.Fragment>
        <SimpleButton
          styles={{ marginLeft: "0px", marginBottom: "25px" }}
          icon={<i className="fa fa-plus margin-right-5px" />}
          text="TAMBAH"
          secondary={isDisable}
          disabled={isDisable}
          onClick={onAddData}
        />
        <style>
          {`
            .MuiTablePagination-root {
              height: 120px !important;
              min-height: 120px !important;
              padding-top: 20px !important;
              padding-bottom: 20px !important;
            }

            .MuiTablePagination-toolbar {
              min-height: 120px !important;
            }
          `}
        </style>

        <SimpleDataTable
          key={`${pagination.totalData}-${pagination.page}`}
          tableContainerStyles={{
            MuiTablePagination: { height: "160px" }, // contoh height
          }}
          data={dataTable}
          columns={this.getTableColumn()}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={{...defaultTableChange(this.handleChangePage, this.handleChangeRowsPerPage), serverSide: false}}
          footerAdditionalButtons={
            <FlexView column style={{ gap: "10px", alignItems: "flex-end" }}>
              <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                <p>Total HET Real (Rp)</p>
                <SimpleInput
                  readOnly
                  containerclassname="margin-bottom-none"
                  value={FormatCurrencyRupiah({ number: totalHet })}
                />
              </FlexView>

              <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                <p>Total Ongkos Kerja (Rp)</p>
                <SimpleInput
                  readOnly
                  containerclassname="margin-bottom-none"
                  value={FormatCurrencyRupiah({ number: totalOngkosKerja })}
                />
              </FlexView>

              <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                <p>Total Amount (Rp)</p>
                <SimpleInput
                  readOnly
                  containerclassname="margin-bottom-none"
                  value={FormatCurrencyRupiah({ number: totalAmount })}
                />
              </FlexView>
            </FlexView>
          }
        />
      </React.Fragment>
    );
  }
}
